/**
 * Additional direct Ref prevents reading old resize entry data
 * Backwards compatible with ResizeObserverCallback if preferred
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
